export default __webpack_public_path__ + "static/media/13.c02ce0da.png";